module.exports = __webpack_public_path__ + "media/images/components/landing_pages/reassurance_cards/efficient@2x-abef3753ab311ad21be7fac320cd22b9.png";